"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedCollectionResult = exports.PlatformSource = exports.AskSnippetResponseType = void 0;
var AskSnippetResponseType;
(function (AskSnippetResponseType) {
    AskSnippetResponseType["SNIPPETS"] = "SNIPPETS";
    AskSnippetResponseType["NEW"] = "NEW";
})(AskSnippetResponseType || (exports.AskSnippetResponseType = AskSnippetResponseType = {}));
var PlatformSource;
(function (PlatformSource) {
    PlatformSource["WEB"] = "WEB";
    PlatformSource["GMAIL"] = "GMAIL";
    PlatformSource["OUTLOOK"] = "OUTLOOK";
    PlatformSource["SLACK"] = "SLACK";
    PlatformSource["TEAMS"] = "TEAMS";
    PlatformSource["IOS_MOBILE"] = "IOS_MOBILE";
    PlatformSource["ANDROID_MOBILE"] = "ANDROID_MOBILE";
    PlatformSource["FRONT"] = "FRONT";
})(PlatformSource || (exports.PlatformSource = PlatformSource = {}));
var EmbedCollectionResult;
(function (EmbedCollectionResult) {
    EmbedCollectionResult["SUCCESS"] = "SUCCESS";
    EmbedCollectionResult["STARTED"] = "STARTED";
    EmbedCollectionResult["FAIL"] = "FAIL";
    EmbedCollectionResult["TOO_LARGE"] = "TOO_LARGE";
})(EmbedCollectionResult || (exports.EmbedCollectionResult = EmbedCollectionResult = {}));
